import React, { useMemo } from "react";

import { FacilityIssueText } from "./FacilityIssueText";
import { calculateFacilityIssues } from "./utils";
import { LocationData } from "../../../models/LocationData";

import "./styles.scss";

interface IFacilityIssuesIconProps {
  facility: LocationData;
}

/**
 * This component displays a warning icon with a tooltip that shows issues for a given facility.
 * If there are no issues, it does not display anything.
 * Currently, the only issue we check for is if the facility has no recent profile_booleans, indicating failure to fetch data.
 * Thus, we check for a recent profile_booleans directly.
 * In the future, we may want to flesh out a location_issues model that can be handled by the backend.
 * In that case, this component should be refactored.
 */
export const FacilityIssuesIcon: React.FunctionComponent<
  IFacilityIssuesIconProps
> = (props) => {
  const { facility } = props;

  // This function should be completely overhauled if we want to move to a backend model for location_issues.
  const issues = useMemo(() => {
    return calculateFacilityIssues(facility);
  }, [facility]);

  if (issues.length === 0) {
    return null;
  }

  return (
    <span className="facility-issues-icon">
      <i className="icons icons-warning" />
      <span className="facility-issues-tooltip">
        {issues.map((issue) => (
          <FacilityIssueText key={issue.title} issue={issue} />
        ))}
      </span>
    </span>
  );
};
